import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';
import { useNotification } from 'shared/hooks';
import { TextEditor } from 'shared/components/data-display/editors';
import { VARIANTS } from 'shared/constants';

/**
 * @param {Object} props
 * @param {Function} props.setNewPassword
 * @param {boolean} props.disabled
 * @param {React.ReactNode} [props.children=null]
 */
export default function PasswordForm(props) {
  const {
    children,
    setNewPassword,
    disabled,
  } = props;

  const notification = useNotification();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const submit = async () => {
    if (password !== passwordConfirm) {
      notification.pushError('Passwords do not match');
      return;
    }

    if (await setNewPassword(password)) {
      notification.pushSuccess('Updated password');
    }
  };

  return (
    <Grid container spacing={1} sx={{ justifyContent: 'end' }}>
      <Grid size={12}>
        {children}
      </Grid>
      <Grid size={12}>
        <TextEditor
          type="password"
          autoComplete="new-password"
          required
          setValue={(value) => setPassword(value)}
          value={password}
          label="New Password"
        />
      </Grid>
      <Grid size={12}>
        <TextEditor
          type="password"
          autoComplete="new-password"
          required
          setValue={(value) => setPasswordConfirm(value)}
          value={passwordConfirm}
          label="Confirm New Password"
        />
      </Grid>
      <Grid>
        <Button
          onClick={submit}
          variant={VARIANTS.contained}
          disabled={disabled}
        >
          Update Password
        </Button>
      </Grid>
    </Grid>
  );
}
